import classNames from 'classnames';

import Link from '~/shared/components/link';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import type { TagType } from '~/shared/types/tag-type';

import '~/shared/components/tags/tags.scss';

type TagsPropsType = {
  tags: TagType[];
};

const Tags = ({ tags, isWhite = false, lng }: TagsPropsType) => (
  <div className="tags">
    {tags.map((tag) => (
      <Link
        itemProp="url"
        href={getLocaleLink(`/posts/tags/${tag.alias}`, lng)}
        className={classNames('tag', {
          'tag--white': isWhite,
        })}
        key={tag.alias}
      >
        <span>{tag.name}</span>
      </Link>
    ))}
  </div>
);

export default Tags;
